export default {
  path: '/login',
  name: 'Login',
  component: () => import(/* webpackChunkName: "login" */ '../../views/Login.vue'),
  meta: {
    requiresUnauth: true,
  },
};
